import React from "react";

const Tabs = ({ tabs, aTab, sTab }) => {
  return (
    <div className=" w-[fit-content] border-t-[3px] border-gray-200">
      <div className="flex ">
        {tabs.map((tab, index) => (
          <button
            key={index}
            className={`relative hover:cursor-pointer px-4 py-2 text-[10px] font-medium transition-colors duration-200 ${
              aTab === tab
                ? "text-black bg-blue-50 font-semibold"
                : "text-gray-500 hover:text-black"
            }`}
            onClick={() => sTab(tab)}
          >
            {tab}
            {aTab === tab && (
              <span className="absolute -top-[3px] left-0 w-full h-[3px] bg-blue-500" />
            )}
          </button>
        ))}
      </div>
    </div>
  );
};

export default Tabs;
